import script from "./OrderSubmit.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSubmit.vue?vue&type=script&setup=true&lang=js"

import "./OrderSubmit.vue?vue&type=style&index=0&id=74be986d&lang=scss&scoped=true"

import exportComponent from "D:\\obj\\komanch\\web-company\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74be986d"]])

export default __exports__